<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <soil-field-form-groups
        :submission="submission_data"
        :index="index"
        @onFieldChange="onFieldChange"
      ></soil-field-form-groups>
      <hr />
      <b-form-group label="Zone" :label-cols="3">
        <b-form-input
          type="text"
          v-model="submission_data.submission_soil.zone"
          placeholder="Enter Project Zone (optional)"
          @change="emitSubmissionChange"
        ></b-form-input>
      </b-form-group>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <hr />
        <soil-sample-form-group
          v-for="(sample, sampleIndex) in submission_data.samples"
          :key="sampleIndex"
          :sample="sample"
          :addOns="addOns"
          :index="sampleIndex"
          :testPackage="testPackage"
          :allTestPackages="allTestPackages"
          @onSampleChange="onSampleChange"
        ></soil-sample-form-group>
      </div>
      <hr />
      <soil-next-crop-form-groups
        :submission="submission_data"
        :index="index"
        @onNextCropChange="onNextCropChange"
      ></soil-next-crop-form-groups>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <div v-if="serviceQuestions && serviceQuestions.models.length">
        <hr />
        <service-question
          v-for="(serviceQuestion, index) in serviceQuestions.models"
          :serviceQuestion="serviceQuestion"
          :key="index"
        ></service-question>
      </div>
      <b-button variant="danger" @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>

<script>
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";
import SoilFieldFormGroups from "./SoilFieldFormGroups";
import SoilNextCropFormGroups from "./SoilNextCropFormGroups";
import SoilSampleFormGroup from "./SoilSampleFormGroup";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TurnAroundSelect from "../../TurnAroundSelect";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";

export default {
  name: "ZoneSoilForm",
  components: {
    TurnAroundSelect,
    SoilNextCropFormGroups,
    SoilSampleFormGroup,
    SoilFieldFormGroups
  },
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    index: {
      type: Number,
      default: null
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    },
    testPackage: {
      type: Object,
      default: () => (null),
    },
    allTestPackages: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      submission_data: null
    };
  },
  methods: {
    onFieldChange(data) {
      if (data) {
        this.submission_data.submission_soil.grower = data.grower;
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;
        this.submission_data.submission_soil.irrigated = data.irrigated;
        this.submission_data.submission_soil.zone = data.zone;

        if (data.customer_grower_id) {
          this.submission_data.submission_soil.customer_grower_id = data.customer_grower_id
        }

        if (data.customer_field_id) {
          this.submission_data.submission_soil.customer_field_id = data.customer_field_id
        }
        this.emitSubmissionChange();
      }
    },
    onSampleChange(params) {
      if (params) {
        let sample = params.sample;
        let index = params.index;
        if (
          this.submission_data.samples &&
          this.submission_data.samples.length &&
          sample &&
          index !== null
        ) {
          this.submission_data.samples.splice(index, 1, sample);
          this.emitSubmissionChange();
        }
      }
    },
    onNextCropChange(projections) {
      if (projections) {
        this.submission_data.submission_soil.projections = projections;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.submission_data.turnaround_id = turnaround.id;
        this.emitSubmissionChange();
      } else {
        this.submission_data.turnaround = null;
        this.submission_data.turnaround_id = null;
        this.emitSubmissionChange();
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.emitSubmissionChange();
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
